// Languages without app translation that should fallback to a given app translation
export const FALLBACK_LANGUAGES = [
    'zh-TW',
    'zh-HK',
    'zh-CN',
    'zh',
    'nn',
    'fr',
    'pt',
    'en-GB',
    'en-US',
];

// Includes all languages that are valid in the app
export const ALLOWED_LANGUAGES = [
    ...FALLBACK_LANGUAGES,
    'en',
    'ar',
    'cs',
    'cy',
    'da',
    'de',
    'es-ES',
    'es-US',
    'fi',
    'fr-CA',
    'fr-FR',
    'ga',
    'he',
    'id',
    'it',
    'ja',
    'ko',
    'nb',
    'nl',
    'pl',
    'pt-BR',
    'sv',
    'th',
    'vi',
    'zh-Hans',
    'zh-Hant',
];
